// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__txmSH","navigation_wrapper":"navigation_navigation_wrapper__BAHlK","selected":"navigation_selected__sr-QY"};